import { formatUnits18, short } from '../config'

/** "100,000,000 CBON" for messages (TokenAmount renders the same as JSX). */
export const tokenAmountText = (raw: string | bigint | undefined, meta: { symbol?: string; decimals?: number }, token?: string, digits = 4) =>
  raw === undefined ? '' : `${formatUnits18(raw, meta.decimals ?? 18, digits)} ${meta.symbol ?? (token ? short(token) : '')}`.trim()
